export * from './capitalize-words.pipe';
